import classes from '../Pages.module.css';
import {Row,Col, Tabs, Skeleton, message} from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext} from 'react';
import BasicDetails from './BasicDetails'
import AddressDetails from './AddressDetails';
import Education from './Education';
import Language from './Language'
import Experience from './Experience'
import Health from './Health';
import Dependent from './Dependent';
import Training from './Training';
import Membership from './Membership';
import Department from './Department';
import OtherDetails from './OtherDetails';
import City from './City';
import Skill from './Skill';
import Designation from './Designation';
import DocumentVerification from './DocumentVerification';

import SyncLoader from "react-spinners/SyncLoader";
import { useNavigate, useLocation } from "react-router-dom";

const { TabPane } = Tabs;

// const identifiers = ['education', 'languages', 'experience', 'health', 'dependent', 'training', 'membership', 'department', 'skill', 'city', 'documentVerification'];
const identifiers =[]
const EmployeeView = (props) => {

    const employeeData = useContext(DataContext)
    const history = useNavigate();

    const [loading, setLoading] = useState(false)
    const [editMode, setEditMode] = useState(true)
    const [allData, setAllData] = useState({
        "employeeMaster": [
            {
                "employee_code": null,
                "pf_req": null,
                "rest_day": null,
                "employee_name": null,
                "employee_mname": null,
                "employee_lname": null,
                "email": null,
                "ctc": null,
                "shift": null,
                "employee_desig_code": null,
                "gross_salary": null,
                "qualifications": null,
                "employee_grade_code": null,
                "experience": null,
                "employee_dept_code": null,
                "validity_days": null,
                "earned_lv": null,
                "hod": null,
                "casual_lv": null,
                "tolerance": null,
                "tolerance_type": null,
                "employee_type_code": null,
                "limit": null,
                "limit_type": null,
                "overtime": null,
                "salary_norm_code": null,
                "acc_group_code": null,
                "adhar_no": null,
                "father_name": null,
                "mother_name": null,
                "maritial_status": null,
                "dob": null,
                "sex": null,
                "mediclaim_amount": null,
                "height": null,
                "doc": null,
                "blood_group": null,
                "doj": null,
                "weight": null,
                "distance_native": null,
                "dow": null,
                "dol": null,
                "pan_number": null,
                "insurance_amount": null,
                "bank_name": null,
                "branch_address": null,
                "religion_code": null,
                "nationality": null,
                "pfaccount_no": null,
                "bank_acc": null,
                "esi_number": null,
                "overtime_1": null,
                "term_insurance_premium": null,
                "ifsc_code": null,
                "hadicapped": null,
                "probation_period": null,
                "term_insurance_value": null,
                "file_no": null,
                "reporting_to": null,
                "card_no": null,
                "uan": null,
                "name_in_bank": null,
                "disp_name": null,
                "reference": null,
                "address": null,
                "country_code": null,
                "state_code": null,
                "city_code": null,
                "pincode": null,
                "phone": null,
                "mobile": null,
                "fax": null,
                "address_present": null,
                "country_code_present": null,
                "state_code_present": null,
                "city_code_present": null,
                "pincode_present": null,
                "phone_present": null,
                "address_corr": null,
                "country_code_corr": null,
                "state_code_corr": null,
                "city_code_corr": null,
                "pincode_corr": null,
                "phone_corr": null,
                "unit_code": null
            }
            
        ],
        "education": [],
        "languages": [],
        "experience": [],
        "health": [],
        "dependent": [],
        "training": [],
        "membership": [],
        "department": [],
        "designation": [],
        "skill": [],
        "city": [],
        "documentVerification": []
    })
    const [ad, setAD] = useState(null)

    useEffect(() => {
        
        setEditMode(true)
        setAD(null)
        setLoading(false)
        axios
            .get(employeeData.URL + '/api/v1/employees/additional-data',{
                withCredentials: true
            })
            .then((response) => {

                console.log(response);
                setAD(ad => {
                    let newad = response.data.data
                    return ({
                        ...newad,
                        GENDER: {
                            fields: [{name: "KEY"},{name: "VALUE"}],
                            rows: [{KEY: "M", VALUE: "Male"},{KEY: "F", VALUE: "Female"}]
                        },
                        HANDICAPPED: {
                            fields: [{name: "KEY"},{name: "VALUE"}],
                            rows: [{KEY: "Y", VALUE: "Yes"},{KEY: "N", VALUE: "No"}]
                        },
                        RWS: {
                            fields: [{name: "KEY"},{name: "VALUE"}],
                            rows: [{KEY: "Y", VALUE: "Yes"},{KEY: "N", VALUE: "No"}]
                        },
                        MARITIAL_STATUS: {
                            fields: [{name: "KEY"},{name: "VALUE"}],
                            rows: [{KEY: "M", VALUE: "Married"},{KEY: "U", VALUE: "Unmarried"}]
                        }
                    });
                })
            })
            .catch((error) => {
                console.log(error);
            })
        
    }, [])

    const handleSave = (event) => {

        var formv = true;
        const requiredFields = ['employee_name', 'email', 'adhar_no', 'employee_type_code', 'dob', 'doj','sex','ctc','gross_salary','shift'];
        const missingFields = requiredFields.filter(field => !allData.employeeMaster[0][field]);

        if (missingFields.length > 0) {
            formv = false;
            message.error({
                content: `Please fill All the following required field`,
                className: 'custom-class',
                style: {
                    marginTop: '1vh',
                },
            });
        }

        identifiers.forEach(val => {
            let count = 0;
            allData[val].forEach(data => {
                
                if(!data){

                    formv = formv&&false
                    if(count === 0){
                        message.error({
                            content: 'Empty Fields In ' + val.toUpperCase() + ' Tab!!!',
                            className: 'custom-class',
                            style: {
                                marginTop: '1vh',
                            },
                        });
                    }

                    count = count + 1;
                }
            })
        })

        if(formv){
            setLoading(true)
            const postData = {
                ...allData,
                department: allData.department.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        DATE_JOIN: dep.DATE_JOIN ? dep.DATE_JOIN.format('DD-MM-YYYY') : null,
                                        DATE_RELEASE: dep.DATE_RELEASE ? dep.DATE_RELEASE.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
                designation: allData.designation.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        DATE_JOIN: dep.DATE_JOIN ? dep.DATE_JOIN.format('DD-MM-YYYY') : null,
                                        DATE_RELEASE: dep.DATE_RELEASE ? dep.DATE_RELEASE.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
                dependent: allData.dependent.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        DOB: dep.DOB ? dep.DOB.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
                experience: allData.experience.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        FROM_DATE: dep.FROM_DATE ? dep.FROM_DATE.format('DD-MM-YYYY') : null,
                                        TO_DATE: dep.TO_DATE ? dep.TO_DATE.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
                membership: allData.membership.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        SINCE_DATE: dep.SINCE_DATE ? dep.SINCE_DATE.format('DD-MM-YYYY') : null,
                                        EXPIRY_DATE: dep.EXPIRY_DATE ? dep.EXPIRY_DATE.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
                training:  allData.training.map(dep => {
                                return(
                                    {
                                        ...dep,
                                        START_DATE: dep.START_DATE ? dep.START_DATE.format('DD-MM-YYYY') : null,
                                    }
                                )
                            }),
            }

            console.log(postData);

            axios
                .post(employeeData.URL + '/api/v1/employees', postData,  {
                    withCredentials: true,
                    credentials: 'include',
                })
                .then((response) => {
                    message.success({
                        content: 'Employee Created Successfully!!!',
                        className: 'custom-class',
                        style: {
                            marginTop: '2vh',
                        },
                    });
                    setLoading(false)
                    history('/admin/employee/emp-detail')
                })
                .catch((err) => {
                    message.error({
                        content: 'An Error Occurred!!!!',
                        className: 'custom-class',
                        style: {
                            marginTop: '2vh',
                        },
                    });
                    setLoading(false)
                });
        }
        
    }

    const handleCancel = (event) => {

        setLoading(false)
        history('/admin/employee/emp-detail')
    }

    return(
        <>
            {
                ad
                ?
                <Row className = {classes['RowP']}>
                    <Col lg = {editMode ? 13 : 19} md = {editMode ? 13 : 19} className = {classes['Col']} >

                    </Col>
                    {
                        editMode
                        ?
                        <>
                            <Col md = {4} >
                                {
                                    loading
                                    ?
                                    <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                                    :
                                    <button
                                                        style={{
                                                          padding: "7px 30px 14px 24px",
                                                          borderRadius: "50px",
                                                          background: "transparent",
                                                          width: "100%",
                                                          border: "none",
                                                          outline: "none",
                                                          fontSize: "16px",
                                                          fontWeight: "600",
                                                          lineHeight: "1.5",
                                                          color: "#071e54",
                                                          WebkitAppearance: "none",
                                    
                                                          boxShadow:
                                                            "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                                          height: "40px",
                                    
                                                          // Ensure the button takes full width
                                                        }}
                                                        onClick={(event) => handleSave(event)}
                                                        className={classes["ProfileButtonn"]}
                                                        id="save"
                                                        onMouseOver={(event) => {
                                                          event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                                        }}
                                                        onMouseOut={(event) => {
                                                          event.target.style.boxShadow =
                                                            "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                                        }}
                                                      >Save</button>
                                }
                            </Col>
                            <Col md = {4} >
                                {
                                    loading
                                    ?
                                    <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                                    :
                                    <button
                                                        style={{
                                                          padding: "7px 30px 14px 24px",
                                                          borderRadius: "50px",
                                                          background: "transparent",
                                                          width: "100%",
                                                          border: "none",
                                                          outline: "none",
                                                          fontSize: "16px",
                                                          fontWeight: "600",
                                                          lineHeight: "1.5",
                                                          color: "#071e54",
                                                          WebkitAppearance: "none",
                                    
                                                          boxShadow:
                                                            "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                                          height: "40px",
                                    
                                                          // Ensure the button takes full width
                                                        }}
                                                        onClick={(event) => handleCancel(event)}
                                                        onMouseOver={(event) => {
                                                          event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                                        }}
                                                        onMouseOut={(event) => {
                                                          event.target.style.boxShadow =
                                                            "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                                        }}
                                                        className={classes["ProfileButtonn"]}
                                                      >Cancel</button>
                                }
                                
                            </Col>
                        </>
                        :
                        <Col md = {4} >
                            <button onClick = {() => setEditMode(true)} className = {classes['ProfileButton']}>Edit Details</button>
                        </Col>
                    }
                    <Col lg = {1} md = {1} >

                    </Col>
                    <Col lg = {24} md = {24} className = {classes['Col']}>
                        <div className = {classes['EditView']}>
                            <Tabs defaultActiveKey="0" centered style = {{ height: "100%"}} tabPosition={"left"} type = "line" tabBarGutter = "0">
                                <TabPane tab= {<span>Basic Details</span>} key="0">
                                    <BasicDetails create = {true} ad = {ad} setData = {setAllData} data = {allData.employeeMaster[0]} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Address</span>} key="1">
                                    <AddressDetails  ad = {ad} setData = {setAllData} data = {allData.employeeMaster[0]} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Education</span>} key="2">
                                    <Education  ad = {ad} setData = {setAllData} data = {allData.education} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Language</span>} key="3">
                                    <Language  ad = {ad} setData = {setAllData} data = {allData.languages} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Experience</span>} key="4">
                                    <Experience  ad = {ad} setData = {setAllData} data = {allData.experience} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Health</span>} key="5">
                                    <Health  ad = {ad} setData = {setAllData} data = {allData.health} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Dependent</span>} key="6">
                                    <Dependent  ad = {ad} setData = {setAllData} data = {allData.dependent} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Training</span>} key="7">
                                    <Training  ad = {ad} setData = {setAllData} data = {allData.training} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Membership</span>} key="8">
                                    <Membership  ad = {ad} setData = {setAllData} data = {allData.membership} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Department</span>} key="10">
                                    <Department  ad = {ad} setData = {setAllData} data = {allData.department} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Designation</span>} key="11">
                                    <Designation ad = {ad} setData = {setAllData} data = {allData.designation} editMode = {editMode} />
                                </TabPane>
                                <TabPane tab= {<span>Skills</span>} key="12">
                                    <Skill   ad = {ad} setData = {setAllData} data = {allData.skill} editMode = {editMode} />  
                                </TabPane>
                                <TabPane tab= {<span>City</span>} key="13">
                                  <City   ad = {ad} setData = {setAllData} data = {allData.city} editMode = {editMode} />  
                                </TabPane>
                                <TabPane tab= {<span>Document Verification</span>} key="14">
                                    <DocumentVerification   ad = {ad} setData = {setAllData} data = {allData.documentVerification} editMode = {editMode} /> 
                                </TabPane>
                                <TabPane tab= {<span>Other Details</span>} key="15">
                                    <OtherDetails  ad = {ad} setData = {setAllData} data = {allData.employeeMaster[0]} editMode = {editMode} />
                                </TabPane>
                            </Tabs>
                        </div>
                    </Col>
                
                </Row>
                :
                <>
                    <Skeleton active = {true} />
                    <Skeleton active = {true} />
                    <Skeleton active = {true} />
                    <Skeleton active = {true} />
                </>
            }
           
        </>
    );
}

export default EmployeeView